import React from 'react'
import { ArrayInput, SimpleFormIterator, useTranslate } from 'react-admin'
import KAccordion from 'ui-shared/accordions/KAccordion'
import { DEFAULT_PRICE_RANGE_MAX_QUANTITY } from 'services/cfg/form'
import { noDecimals } from 'services/utils'
import { truncate } from 'services/utils/prices'
import KNumberInput from 'ui-shared/WrappedInputs/KNumberInput'
import VariablePricesInput from './VariablePricesInput'
import FixedPricesInput from './FixedPricesInput'

type Props = {
  hideFixedPrice?: boolean
  hideVariablePrice?: boolean
  source?: string
  label?: string
  isSinglePriceRange?: boolean
}

export const limitToOneDecimal = (n?: string) =>
  !!n ? truncate(Number(n), 1) : n

const StandardPricingInput: React.FC<Props> = ({
  hideFixedPrice = false,
  hideVariablePrice = false,
  source = 'pricing',
  label = 'form.fields.pricing',
  isSinglePriceRange = false,
}) => {
  const translate = useTranslate()

  return (
    <KAccordion
      accordionTitle={translate('form.headers.standardPricingAccordion')}
    >
      <ArrayInput source={source} label={label} defaultValue={[{}]}>
        <SimpleFormIterator
          disableReordering
          disableAdd={isSinglePriceRange}
          disableRemove={isSinglePriceRange}
        >
          <KNumberInput
            source={'maxQuantity'}
            label="form.fields.maxQuantity"
            defaultValue={DEFAULT_PRICE_RANGE_MAX_QUANTITY}
            parse={noDecimals}
          />
          <VariablePricesInput
            style={
              hideVariablePrice ? { visibility: 'hidden', height: '0' } : {}
            }
          />

          <FixedPricesInput
            style={hideFixedPrice ? { visibility: 'hidden', height: '0' } : {}}
          />
        </SimpleFormIterator>
      </ArrayInput>
    </KAccordion>
  )
}

export default StandardPricingInput
